import { describeError } from '@/lib/describe-error';
import { Button } from './Button';
import { Icon } from './Icon';

/** The first 8 characters of a correlation id: enough for support to find it, short enough to read out. */
export const shortReference = (reference: string) => reference.slice(0, 8);

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { title, message, reference } = describeError(error);
  return (
    <div role="alert" className="flex flex-col items-center gap-3 px-6 py-12 text-center">
      <span className="grid size-12 place-items-center rounded-full bg-danger-soft text-danger">
        <Icon name="alert" size={24} />
      </span>
      <h2 className="text-lg font-semibold text-ink">{title}</h2>
      <p className="max-w-xs text-sm text-muted">{message}</p>
      {reference && (
        <p className="text-xs text-faint">
          Support reference{' '}
          <span
            className="font-medium tabular-nums"
            title={reference}
            aria-label={`Support reference ${reference}`}
          >
            {shortReference(reference)}
          </span>
        </p>
      )}
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
